module.exports = __webpack_public_path__ + "static/media/user.2e0eb43d.svg";